<template>
	<div>
		<input name="zip" class="form-control" required="required" list="ziplist" :value="id" @change="ChangeEntry" @select="SelectEntry">
		<datalist id="ziplist">
			<option v-for="entry in content" :value="entry.id">{{ entry.text }}</option>
		</datalist>
	</div>
</template>

<script>
import { formatStr } from "root/tools.js"

export default {
	props: {
		"src": Array,
		"value": [String, Number],
		"index": String,
		"format": String
	},

	mounted () {
		this._id = this.value
	},

	data () {
		return {
			_id: 0,
		}
	},

	methods: {
		SelectEntry (aBlubb) {
			console.log("Select", aBlubb)
		},

		ChangeEntry (aBlubb) {
			console.log("Change", aBlubb)
		}
	},

	computed: {
		id: {
			get () {
				// console.log("[CUSTOM-DROPDOWN] address_id (get)", this._address_id)
				return this._id
			},

			set (newID) {
				console.log("[CUSTOM-DROPDOWN] address_id (set)", newID)
				this._id = newID
				this.$emit("input", newID)
			}
		},

		content () {
			// console.log("[CUSTOM-DROPDOWN] addresses (get) src:", this.src)

			if (this.src === undefined) {
				return []
			}

			const result = this.src.map(entry => {
				return {
					id: entry[this.index],
					text: formatStr(entry, this.format)
				}
			})

			// console.log("[CUSTOM-DROPDOWN] addresses (get) result:", result)

			return result
		}
	}
}
</script>


// WEBPACK FOOTER //
// custom-search-input.vue?4d573494